import { OndemandVideo } from '@mui/icons-material';
import { Box, styled } from '@mui/material';

export interface PlaylistThumbnailProps {
  size?: 'small' | 'medium';
}

const Container = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size: 'small' | 'medium' }>(({ theme, size }) => ({
  width: size === 'small' ? 32 : 64,
  height: size === 'small' ? 32 : 64,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.grey[200],
  border: `1px solid ${theme.palette.grey[300]}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const Icon = styled(OndemandVideo)(({ theme }) => ({
  fontSize: 20,
  color: theme.palette.text.secondary,
}));

export const PlaylistThumbnail = ({ size = 'medium' }: PlaylistThumbnailProps) => {
  return (
    <Container size={size}>
      <Icon />
    </Container>
  );
};
